import {searchFormReducer, authReducer} from '@travel-frontend/ui-components';
import {combineReducers} from 'redux';

export const uiStateReducer = combineReducers({
  searchForm: searchFormReducer,
  auth: authReducer,
});

export type UIState = ReturnType<typeof uiStateReducer>;
